import React, { useState, useRef, useEffect, useCallback } from "react";
import cornerstone, { getLayers } from "cornerstone-core";
import cornerstoneTools from "cornerstone-tools";
import axios from "axios";
import { useDispatch, useSelector } from "react-redux";
import {
  addStaticLineWithText,
  drawRectangleStatic,
  panImageEvent,
  ZoomMouseWheel,
  modifyOnPolylineClick,
  updateSelectedPointsLine,
  deleteSelectedPointsLine,
  addAnnotationsOPT,
  addAnnotationsOPTUpdate,
  applyFluidSegmentationToStack,
  normalizeOptAnnotationsByFrame,
  optAnnotationsHaveSavedFluid,
  isCornerstoneElementEnabled,
  safeUpdateImage,
} from "./utils";
import { ezdalinescheck } from "../actions/dcm_actions";
import { drawBrushPixels } from "../tools/util/drawBrush";
import { API_URL, ML_API_URL } from "../../../Endpoints";
import { lineColors } from "../configs/layers";
import drawJoinedLines from "../tools/annotation/drawing/drawJoinedLines";
import {
  notifyFluidEraseHoverImageCoords,
  syncFluidEraseDiameter,
  adjustFluidEraseDiameter,
  syncAiSegmentationEraseDiameter,
  adjustAiSegmentationEraseDiameter,
} from "../tools/AiSegmentationEraser";
import {
  centerlineToFluidRowDatums,
  polygonFillToFluidRowDatums,
  fluidLabelColorFromSettings,
  interpolateSegment,
  upsertFluidManualDraftRowSegments,
  commitFluidManualDatums,
  removeFluidManualDraft,
  clampFluidManualBrushRadius,
  FLUID_MANUAL_BRUSH_RADIUS_MIN,
  FLUID_MANUAL_BRUSH_RADIUS_MAX,
} from "../utils/fluidManualBrush";
import { snapshotFluidBaselinesForStack } from "../utils/fluidFrameState";
import {
  applyImageContrastToElement,
  captureBaselineVoiFromElement,
  captureBaselineVoiFromImage,
  getOptImageContrastValue,
} from "../utils/imageContrast";

import cornerstoneWADOImageLoader from "cornerstone-wado-image-loader";
import { fitViewportToWidth } from "./viewportUtils";
import { applyTopconOptNearestNeighborCanvas } from "../utils/topconOptDisplayStretch";
import {
  get_normalized_x,
  get_slope_from_line,
  intercept_from_line,
} from "../utils/basic_utils";
import {
  createContours,
  simplifyContour,
  get_thickness_map,
} from "./processing/thickness";
import { useLocation } from "react-router-dom";

const getModule = cornerstoneTools.getModule;
const { getters, setters } = getModule("segmentation");

let toolUpdateva = false;
export default function OPTViewer(props) {
  const dispatch = useDispatch();
  let { search } = useLocation();

  const query = new URLSearchParams(search);
  const dicom_data = useSelector((state) => state.dcm);

  const dicomDataRef = useRef(dicom_data);
  dicomDataRef.current = dicom_data;

  const opData = dicom_data.dicom_data[props.id];

  const [elmentEnabled, setElementEnabled] = useState(false);
  const dcmRef = useRef(null);
  const baselineVoiRef = useRef(null);
  const StackScrollMouseWheelTool = cornerstoneTools.StackScrollMouseWheelTool;
  const [rectPoint, setRectPoint] = useState([0, 0, 0, 0]);

  /** Manual fluid Brush / Paint: collect centerline → commit FluidSegmentation on mouse-up */
  const fluidManualSessionRef = useRef({ active: false, points: [] });

  const isFluidManualPaintTool = (tool) => tool === "Paint";

  const isFluidSegmentationEraserTool = (tool) =>
    tool === "FluidSegmentationEraser";

  const isAiSegmentationEraserTool = (tool) => tool === "AiSegmentationEraser";

  const isSegmentationEraserTool = (tool) =>
    isFluidSegmentationEraserTool(tool) || isAiSegmentationEraserTool(tool);

  const STACK_SCROLL_BLOCKING_KEYS = new Set(["Shift", "Alt", "a", "A"]);

  const isSegmentationEraserCtrlResize = (dc, nativeEvt) =>
    isSegmentationEraserTool(dc.selectedTool) &&
    (dc.selectedKey === "Control" || Boolean(nativeEvt?.ctrlKey));

  //const [loadCounter, setLoadCounter] = useState(0)
  const loadCounter = useRef(0);
  const isRestoringAnnotationsRef = useRef(false);
  const getToolsState = () => {
    if (!isCornerstoneElementEnabled(dcmRef.current)) {
      return;
    }

    // Get tool state for all enabled tools

    const state = {};
    dicom_data.drawingTools.forEach((tool) => {
      let msms;
      try {
        msms = cornerstoneTools.getToolState(dcmRef.current, tool);
      } catch (_error) {
        return;
      }

      if (tool == "Length" && msms) {
        const pixel_spacing = opData.OP.metadata.pixel_spacing;
        msms.pixelSpacing = pixel_spacing;
        msms.data = msms.data.map((obj) => ({
          ...obj,
          pixelSpacing: {
            rowPixelSpacing: pixel_spacing.rowPixelSpacing,
            colPixelSpacing: pixel_spacing.columnPixelSpacing,
          },
        }));
      }
      state[tool] = msms;
    });
    try {
      const labelMap = getters.labelmap2D(dcmRef.current);
      if (labelMap?.labelmap2D && labelMap?.labelmap3D) {
        state.Brush = { data: [labelMap.labelmap2D, labelMap.labelmap3D] };
      }
    } catch (_labelmapErr) {
      // Segmentation labelmap may be uninitialized when using fluid brush/eraser only
    }

    // dispatch({
    //   type: "ANNOTATION_CHANGE_REQUEST",
    //   stack_id: query.get("stack_id"),
    //   key: "OP",
    //   payload: {
    //     index: 0,
    //     annot_type: "LisonProbe",
    //     action_type: "Add_Lison_Length_point",
    //   },
    // });

    dispatch({
      type: "SET_ANNOTATION_DATA",
      payload: state,
      id: props.id,
      key: "OPT",
    });
    // dispatch({
    //   type: "ANNOTATION_CHANGE_REQUEST",
    //   stack_id: query.get("stack_id"),
    //   key: "OP",
    //   payload: {
    //     index: 0,
    //     annot_type: "Probe",
    //     action_type: "Add_Lison_Length_point",
    //   },
    // });
  };

  const incrementLoadCounter = () => {
    loadCounter.current += 1;
  };

  const clearOptAnnotationToolState = () => {
    if (!opData?.OPT?.stack?.imageIds) {
      return;
    }

    opData.OPT.stack.imageIds.forEach((imageId) => {
      cornerstoneTools.globalImageIdSpecificToolStateManager.restoreImageIdToolState(
        imageId,
        {},
      );
    });
  };

  const get_mask = (points) => {
    axios
      .post(`${API_URL}/get-mask`, {
        data: points,
        image_id: props.id,
        index: opData.OPT.stack.currentImageIdIndex,
      })
      .then((res) => {
        if (points.length === 3 && points[2] === "bg") {
        } else {
          const {
            labelmap2D, // The `Labelmap2D` for this imageId.
            labelmap3D, // The `Labelmap3D` for this stack.
          } = getters.labelmap2D(dcmRef.current);

          // Get cornerstone image
          const image = cornerstone.getImage(dcmRef.current);
          const { columns } = image;

          const shouldErase = true;
          drawBrushPixels(
            res.data,
            labelmap2D.pixelData,
            labelmap3D.activeSegmentIndex,
            columns,
            false,
          );
          cornerstone.updateImage(dcmRef.current);
        }
      })
      .catch((err) => {});
  };

  useEffect(() => {
    if (elmentEnabled) cornerstone.resize(dcmRef.current);
  }, [props.windowWidth, dicom_data.width]);

  const onMeasurementAdded = (e) => {
    if (isRestoringAnnotationsRef.current) {
      return;
    }
    // Get tool state for all enabled tools on measurementAdded

    getToolsState();
  };

  const debouncedDispatch = useCallback(
    debounce((e) => {
      if (isRestoringAnnotationsRef.current) {
        return;
      }
      if (e?.detail.toolName === "Lison") {
        dispatch({
          type: "ANNOTATION_CHANGE_REQUEST",
          stack_id: query.get("stack_id"),
          key: "OP",
          payload: {
            index: 0,
            annot_type: "LisonProbe",
            action_type: "Add_Lison_Length_point",
          },
        });
      }

      // Measurement modified

      getToolsState();
    }, 300),
    [],
  ); // debounce delay set to 300ms

  const onMeasurementModified = (e) => {
    debouncedDispatch(e);
  };
  function debounce(func, delay) {
    let timeoutId;
    return function (...args) {
      clearTimeout(timeoutId);
      timeoutId = setTimeout(() => {
        func.apply(this, args);
      }, delay);
    };
  }
  useEffect(() => {
    // On delete click, delete selected points on line tool
    if (dicom_data.selectedKey === "Delete") {
      let data_line = cornerstoneTools.getToolState(dcmRef.current, "Line");
      if (data_line === undefined) {
        return;
      }
      deleteSelectedPointsLine(data_line);
      cornerstone.updateImage(dcmRef.current);
    }
  }, [dicom_data.selectedKey]);

  useEffect(() => {
    if (elmentEnabled)
      setters.activeSegmentIndex(
        dcmRef.current,
        dicom_data?.settings?.brush?.activeSegment,
      );
  }, [dicom_data?.settings?.brush?.activeSegment]);

  const onMouseClick = (e) => {
    // On cornerstone Mouse chlick event
    if (dicom_data.selectedKey === "Alt") {
      // Modify line edges and vertices on alt+click
      let data_line = cornerstoneTools.getToolState(e.detail.element, "Line");
      if (data_line === undefined) return;

      data_line = data_line.data;

      modifyOnPolylineClick(data_line, e.detail.currentPoints.image);

      cornerstone.updateImage(e.detail.element);
    }
  };

  useEffect(() => {
    if (!elmentEnabled) {
      return;
    }
    opData.OPT.stack.currentImageIdIndex = dicom_data.currentFrame;
    dispatch({
      type: "SET_OPT_STACK",
      payload: opData.OPT.stack,
      id: props.id,
    });
  }, [dicom_data.currentFrame]);

  useEffect(() => {
    if (loadCounter.current % 7 === 0) {
      cornerstoneWADOImageLoader.webWorkerManager.terminate();
    }
  }, [loadCounter.current]);

  const isCornerstoneElementEnabled = (element) => {
    if (!element) {
      return false;
    }
    try {
      cornerstone.getEnabledElement(element);
      return true;
    } catch (_e) {
      return false;
    }
  };

  const finalizeOptDisplay = (element, image = null) => {
    if (!isCornerstoneElementEnabled(element)) {
      return false;
    }

    applyTopconOptNearestNeighborCanvas(cornerstone, element);

    baselineVoiRef.current = image
      ? captureBaselineVoiFromImage(cornerstone, element, image)
      : captureBaselineVoiFromElement(cornerstone, element);

    applyImageContrastToElement(
      cornerstone,
      element,
      getOptImageContrastValue(
        dicomDataRef.current?.settings,
        dicomDataRef.current?.dicom_data?.[props.id],
        dicomDataRef.current?.opMetaData,
      ),
      baselineVoiRef.current,
    );

    return true;
  };

  const displayImageIfEnabled = (element, image) => {
    if (!isCornerstoneElementEnabled(element)) {
      return false;
    }
    cornerstone.displayImage(element, image);
    fitViewportToWidth(element, image);
    finalizeOptDisplay(element, image);
    return true;
  };

  useEffect(() => {
    if (!elmentEnabled || !dcmRef.current || !baselineVoiRef.current) {
      return;
    }

    applyImageContrastToElement(
      cornerstone,
      dcmRef.current,
      getOptImageContrastValue(
        dicom_data?.settings,
        dicom_data?.dicom_data?.[props.id],
        dicom_data?.opMetaData,
      ),
      baselineVoiRef.current,
    );
  }, [
    dicom_data?.settings?.imageContrast?.value,
    dicom_data?.opMetaData,
    dicom_data?.dicom_data?.[props.id]?.OP?.metadata,
    dicom_data?.dicom_data?.[props.id]?.OPT?.metadata,
    elmentEnabled,
  ]);

  useEffect(() => {
    if (!elmentEnabled) {
      return;
    }

    if (dicom_data.changeId !== props.id) {
      return;
    }

    // On Stack image change
    // Only change, if request is from OP change or other OPT image is changed
    if (dicom_data.changeFrameType === "OP") {
      cornerstone
        .loadImage(
          opData.OPT.stack.imageIds[opData.OPT.stack.currentImageIdIndex],
        )
        .then((image) => {
          if (displayImageIfEnabled(dcmRef.current, image)) {
            incrementLoadCounter();
          }
        });
    } else if (dicom_data.changeFrameType === "OPT") {
      if (dicom_data.changeId !== props.id) {
        cornerstone
          .loadImage(
            opData.OPT.stack.imageIds[opData.OPT.stack.currentImageIdIndex],
          )
          .then((image) => {
            if (displayImageIfEnabled(dcmRef.current, image)) {
              incrementLoadCounter();
            }
          });
      }
    }

    // If show mask is enabled, we load the mask
    if (dicom_data?.settings?.brush?.showMasks) {
      if (props.masks.length > opData.OPT.stack.currentImageIdIndex) {
        if (props.masks[opData.OPT.stack.currentImageIdIndex].length > 0) {
          const labelmap2D = getters.labelmap2D(dcmRef.current);

          labelmap2D.labelmap2D.pixelData =
            props.masks[opData.OPT.stack.currentImageIdIndex];
          cornerstone.updateImage(dcmRef.current);
        }
      }
    }

    getToolsState();
  }, [opData.OPT.stack.currentImageIdIndex]);
  //

  useEffect(() => {
    if (elmentEnabled) {
      // On vertical line points changed
      //  Draw vertical line with specified points
      cornerstoneTools.clearToolState(dcmRef.current, "LineStatic");
      if (opData.OP.vertical_line !== null) {
        addStaticLineWithText(dcmRef, opData.OPT.vertical_line, ``);
      }
      cornerstone.updateImage(dcmRef.current);
    }
  }, [opData.OPT.vertical_line]);

  const addRectangleStatic = () => {
    const RectangleStatic_v = cornerstoneTools.RectangleStatic;
    cornerstoneTools.addTool(RectangleStatic_v);
    cornerstoneTools.setToolActive("RectangleStatic", { mouseButtonMask: 1 });
  };
  const addAiSegmentation = () => {
    const AiSegmentation = cornerstoneTools.AiSegmentationTool;
    cornerstoneTools.addTool(AiSegmentation);
    cornerstoneTools.setToolActive("AiSegmentation", { mouseButtonMask: 1 });

    if (!dcmRef.current) {
      return;
    }
    try {
      cornerstone.updateImage(dcmRef.current);
    } catch (_error) {
      // Element may not be enabled yet during initial stack load.
    }
  };

  const addFluidSegmentation = () => {
    const FluidSegmentation = cornerstoneTools.FluidSegmentationTool;
    if (!FluidSegmentation) return;
    cornerstoneTools.addTool(FluidSegmentation);
    cornerstoneTools.setToolPassive("FluidSegmentation");
  };

  const addLineStatic = () => {
    const LineStatic_v = cornerstoneTools.LineStatic;
    cornerstoneTools.addTool(LineStatic_v);
    cornerstoneTools.setToolActive("LineStatic", { mouseButtonMask: 1 });
  };

  const finalizeFluidManualBrushSession = (e) => {
    const session = fluidManualSessionRef.current;
    if (!session.active) return;

    session.active = false;
    const el = e.detail?.element;
    const ptList = session.points.slice();
    session.points = [];

    if (!el || el !== dcmRef.current || !ptList.length) {
      return;
    }

    const imageId = cornerstone.getEnabledElement(el)?.image?.imageId;
    if (!imageId) return;

    const dc = dicomDataRef.current;
    const label = dc.manualFluidTargetLabel;
    if (!label) return;

    const mode = dc.fluidBrushDrawingMode || "stroke";
    const color = fluidLabelColorFromSettings(dc.settings, label);
    const image = cornerstone.getImage(el);
    if (!image) return;

    const cols = image.columns;
    const rows = typeof image.rows === "number" ? image.rows : image.height;

    const rad = dc.fluidManualBrushRadius;
    const r = clampFluidManualBrushRadius(rad);

    /**
     * Match dashbaord-vuejs `libs/2d/useBrush.ts` (Fill ON): thick stroke along the path,
     * then a closing stroke from last → first if needed, then polygon fill of `points`.
     * Stroke-only: same as Pixi path without the fill pass.
     */
    let datums = [];
    if (mode === "fill" && ptList.length >= 3) {
      const first = ptList[0];
      const last = ptList[ptList.length - 1];
      const needsClose = first.x !== last.x || first.y !== last.y;
      const strokePolyline = needsClose ? [...ptList, first] : ptList;
      const strokeDatums = centerlineToFluidRowDatums(
        strokePolyline,
        r,
        label,
        color,
        cols,
        rows,
      );
      const fillDatums = polygonFillToFluidRowDatums(
        ptList,
        label,
        color,
        cols,
        rows,
      );
      datums = strokeDatums.concat(fillDatums);
    } else if (ptList.length) {
      datums = centerlineToFluidRowDatums(ptList, r, label, color, cols, rows);
    }

    if (datums.length) {
      commitFluidManualDatums(imageId, datums, {
        label,
        color,
        alpha: 0.35,
      });
      dispatch({
        type: "MARK_FLUID_FRAME_DIRTY",
        frameIndex: dc.currentFrame,
      });
    }

    cornerstone.updateImage(el);
    getToolsState();
    dispatch({ type: "UPDATE_IMAGE" });
  };

  const onMouseDown = (e) => {
    if (dicom_data.selectedTool === "Lison") {
      let tool_name = dicom_data.selectedTool;
      const tool_v = cornerstoneTools[tool_name + "Tool"];

      cornerstoneTools.addTool(tool_v);
      cornerstoneTools.setToolActive(tool_name, {
        mouseButtonMask: 1,
      });
    }

    const dc = dicomDataRef.current;
    if (
      isFluidManualPaintTool(dc.selectedTool) &&
      dc.manualFluidTargetLabel &&
      !["Shift", "a", "A"].includes(dc.selectedKey)
    ) {
      const pt = e.detail?.currentPoints?.image;
      if (pt && e.detail?.element === dcmRef.current) {
        fluidManualSessionRef.current.active = true;
        fluidManualSessionRef.current.points = [{ x: pt.x, y: pt.y }];
        const imageId = cornerstone.getEnabledElement(dcmRef.current)?.image
          ?.imageId;
        const image = cornerstone.getImage(dcmRef.current);
        if (imageId && image) {
          const color = fluidLabelColorFromSettings(
            dc.settings,
            dc.manualFluidTargetLabel,
          );
          const rFluid = clampFluidManualBrushRadius(dc.fluidManualBrushRadius);
          upsertFluidManualDraftRowSegments(
            imageId,
            fluidManualSessionRef.current.points,
            dc.manualFluidTargetLabel,
            color,
            0.45,
            rFluid,
            image.columns,
            image.rows ?? image.height,
          );
          cornerstone.updateImage(dcmRef.current);
        }
      }
    }

    // Record initial position of static rectangle is shift is pressed
    if (
      ["MOUSE", "Brush", "Paint"].includes(dicom_data.selectedTool) &&
      ["Shift", "a", "A"].includes(dicom_data.selectedKey)
    ) {
      setRectPoint([
        e.detail.currentPoints.image.x,
        e.detail.currentPoints.image.y,
        0,
        0,
      ]);
    }
  };

  const onMouseUp = (e) => {
    if (fluidManualSessionRef.current.active) {
      finalizeFluidManualBrushSession(e);
    }

    dispatch({
      type: "Lison_Input_Submit_Status_changed",
      MlLisonsInputsSubmitStatus: true,
    });
    // if (dicom_data.selectedTool === "Lison") {
    //   dispatch({
    //     type: "ANNOTATION_CHANGE_REQUEST",
    //     stack_id: query.get("stack_id"),
    //     key: "OP",
    //     payload: {
    //       index: 0,
    //       annot_type: "LisonProbe",
    //       action_type: "Add_Lison_Length_point",
    //     },
    //   });
    // }
    // On mouse up, if shift is pressed, we will draw a rectangle
    if (
      dicom_data.selectedTool === "MOUSE" &&
      dicom_data.selectedKey === "Shift"
    ) {
      // also update colors for all points inside that rectangle for each line
      updateSelectedPointsLine(
        cornerstoneTools.getToolState(e.detail.element, "Line"),
        [
          rectPoint[0],
          rectPoint[1],
          e.detail.currentPoints.image.x,
          e.detail.currentPoints.image.y,
        ],
      );

      cornerstoneTools.clearToolState(e.detail.element, "RectangleStatic");
      cornerstone.updateImage(e.detail.element);
    } else if (
      isFluidManualPaintTool(dicom_data.selectedTool) &&
      dicom_data.selectedKey === "a"
    ) {
      // also update colors for all points inside that rectangle for each line
      get_mask([
        rectPoint[0],
        rectPoint[1],
        e.detail.currentPoints.image.x,
        e.detail.currentPoints.image.y,
      ]);

      updateSelectedPointsLine(
        cornerstoneTools.getToolState(e.detail.element, "Line"),
        [
          rectPoint[0],
          rectPoint[1],
          e.detail.currentPoints.image.x,
          e.detail.currentPoints.image.y,
        ],
      );
      cornerstoneTools.clearToolState(e.detail.element, "RectangleStatic");
      cornerstone.updateImage(e.detail.element);
    }
  };
  useEffect(() => {
    if (dicom_data?.OpRef?.current) {
      dispatch({
        type: "dicomRefBscan_changed",
        dicomRef: dcmRef,
      });
    }
  }, [dicom_data.OpRef]);

  // Segmentation Visibility change

  useEffect(() => {
    if (!elmentEnabled) return;
    updateAllAnnotations(opData.OPT.stack.imageIds, "Line", (item) => {
      item.visible = dicom_data?.settings?.Segmentation?.nativeSegmentation;
    });
    cornerstone.updateImage(dcmRef.current);
  }, [dicom_data?.settings?.Segmentation?.nativeSegmentation]);
  useEffect(() => {
    if (!elmentEnabled) return;
    let AiSegmentationtoolData = cornerstoneTools.getToolState(
      dcmRef.current,
      "AiSegmentation",
    );
    // Update AiSegmentation visibility
    updateAllAnnotations(
      opData.OPT.stack.imageIds,
      "AiSegmentation",
      (item) => {
        item.visible = dicom_data?.settings?.Segmentation?.aiSegmentation;
      },
    );
    cornerstone.updateImage(dcmRef.current);
  }, [dicom_data?.settings?.Segmentation?.aiSegmentation]);

  // FluidSegmentation visibility change
  useEffect(() => {
    if (!elmentEnabled) return;

    const toolStateManager =
      cornerstoneTools.globalImageIdSpecificToolStateManager;
    const imgIds = opData.OPT.stack.imageIds;
    imgIds.forEach((imageId) => {
      const imageToolState = toolStateManager.saveImageIdToolState(imageId);
      if (imageToolState && imageToolState["FluidSegmentation"]) {
        const toolData = imageToolState["FluidSegmentation"];
        if (toolData?.data) {
          toolData.data.forEach((item) => {
            const flag =
              dicom_data?.local_settings?.FluidSegmentation?.[item.label];
            item.visible = typeof flag === "boolean" ? flag : true;
          });
        }
        toolStateManager.restoreImageIdToolState(imageId, imageToolState);
      }
    });
    cornerstone.updateImage(dcmRef.current);
  }, [
    dicom_data?.local_settings?.FluidSegmentation?.IRF,
    dicom_data?.local_settings?.FluidSegmentation?.SRF,
    dicom_data?.local_settings?.FluidSegmentation?.PED,
    dicom_data?.local_settings?.FluidSegmentation?.SHRM,
  ]);

  const onMouseDrag = (e) => {
    if (fluidManualSessionRef.current.active) {
      if (e.detail.element !== dcmRef.current) return;
      const cur = e.detail?.currentPoints?.image;
      if (!cur) return;
      const pts = fluidManualSessionRef.current.points;
      if (!pts.length) return;
      const last = pts[pts.length - 1];
      const dx = cur.x - last.x;
      const dy = cur.y - last.y;
      if (dx * dx + dy * dy < 0.25) return;
      const extra = interpolateSegment(last, cur, 0.9);
      for (let i = 1; i < extra.length; i++) {
        pts.push(extra[i]);
      }

      const imageId = cornerstone.getEnabledElement(dcmRef.current)?.image
        ?.imageId;
      const image = cornerstone.getImage(dcmRef.current);
      const dc = dicomDataRef.current;
      if (!imageId || !image || !dc.manualFluidTargetLabel) return;
      const color = fluidLabelColorFromSettings(
        dc.settings,
        dc.manualFluidTargetLabel,
      );
      const rFluid = clampFluidManualBrushRadius(dc.fluidManualBrushRadius);
      upsertFluidManualDraftRowSegments(
        imageId,
        pts,
        dc.manualFluidTargetLabel,
        color,
        0.45,
        rFluid,
        image.columns,
        image.rows ?? image.height,
      );
      cornerstone.updateImage(dcmRef.current);
      return;
    }

    // On mouse drag, if control is pressed, we will pan the image
    if (dicom_data.selectedKey === "Shift") {
      panImageEvent(e);
      return;
    }

    // If we are not in a tool, we will not do anything
    // For this, we draw a temporary rectangle
    if (
      ["MOUSE", "Brush", "Paint"].includes(dicom_data.selectedTool) &&
      ["Shift", "a", "A"].includes(dicom_data.selectedKey)
    ) {
      drawRectangleStatic(
        dcmRef,
        [
          rectPoint[0],
          rectPoint[1],
          e.detail.currentPoints.image.x,
          e.detail.currentPoints.image.y,
        ],
        0,
      );

      cornerstone.updateImage(dcmRef.current);
      return;
    }

    // If selected tool is not drag tool, we will not do anything
    if (dicom_data.selectedTool !== "DragRL") {
      return;
    }

    // Drag Left to right or right to left OCT
    let currentFrameData = opData.OPT.metadata.frames[dicom_data.currentFrame];
    let normalizedX = get_normalized_x(
      e,
      currentFrameData,
      opData.OPT.metadata.meta.width,
    );
    if (normalizedX === null) {
      return;
    }

    let slope = get_slope_from_line(currentFrameData);
    let intercept = intercept_from_line(currentFrameData);

    let yh = slope * normalizedX + intercept;

    dispatch({
      type: "DICOM_CHANGE_VERTICAL_LINE",
      OP: [normalizedX, yh - 50, normalizedX, yh + 50],
      OPT: [
        e.detail.currentPoints.image.x,
        0,
        e.detail.currentPoints.image.x,
        opData.OPT.metadata.meta.height,
      ],
      id: props.id,
    });
  };

  const onMouseMove = (e) => {
    const el = e.detail?.element;
    if (isSegmentationEraserTool(dicom_data.selectedTool)) {
      notifyFluidEraseHoverImageCoords(el, e.detail?.currentPoints?.image);
      return;
    }
    if (cornerstoneTools.fluidEraseHover) {
      cornerstoneTools.fluidEraseHover = null;
      if (el) {
        cornerstone.updateImage(el);
      }
    }
  };

  const onMouseWheel = (e) => {
    const dc = dicomDataRef.current;
    // Zoom on mosue wheel with ctrl key
    if (dc.selectedKey === "Shift") {
      ZoomMouseWheel(e, cornerstone);
      return;
    }
    if (isSegmentationEraserCtrlResize(dc, e.detail?.event)) {
      const spinY =
        typeof e.detail?.spinY === "number" && e.detail.spinY !== 0
          ? e.detail.spinY
          : 0;
      if (spinY !== 0) {
        const isFluid = isFluidSegmentationEraserTool(dc.selectedTool);
        const cur = isFluid
          ? (dc.settings?.brush?.fluidEraserDiameter ?? 20)
          : (dc.settings?.brush?.borderRadius ?? 20);
        const next = isFluid
          ? adjustFluidEraseDiameter(cur, spinY)
          : adjustAiSegmentationEraseDiameter(cur, spinY);
        if (next !== cur) {
          if (isFluid) {
            dispatch({ type: "SET_FLUID_ERASER_DIAMETER", diameter: next });
            syncFluidEraseDiameter(next);
          } else {
            dispatch({ type: "SET_BRUSH_BORDER_RADIUS", borderRadius: next });
            syncAiSegmentationEraseDiameter(next);
          }
          if (dcmRef.current) {
            cornerstone.updateImage(dcmRef.current);
          }
        }
      }
      return;
    }
    if (
      ["z", "Z"].includes(dc.selectedKey) &&
      isFluidManualPaintTool(dc.selectedTool)
    ) {
      const cur = clampFluidManualBrushRadius(dc.fluidManualBrushRadius);
      const next =
        e.detail.spinY > 0
          ? Math.max(FLUID_MANUAL_BRUSH_RADIUS_MIN, cur - 1)
          : Math.min(FLUID_MANUAL_BRUSH_RADIUS_MAX, cur + 1);
      dispatch({ type: "SET_FLUID_MANUAL_BRUSH_RADIUS", radius: next });
      return;
    }
  };

  useEffect(() => {
    if (isFluidManualPaintTool(dicom_data.selectedTool)) {
      const r = clampFluidManualBrushRadius(dicom_data.fluidManualBrushRadius);
      setters.radius(r);
      cornerstone.updateImage(dcmRef.current);
    }
  }, [
    dicom_data.fluidManualBrushRadius,
    dicom_data.selectedTool,
    dicom_data.fluidBrushDrawingMode,
  ]);

  useEffect(() => {
    if (!elmentEnabled || !dcmRef.current) return;
    const imageId = cornerstone.getEnabledElement(dcmRef.current)?.image
      ?.imageId;
    if (imageId) {
      removeFluidManualDraft(imageId);
    }
    fluidManualSessionRef.current.active = false;
    fluidManualSessionRef.current.points = [];
    cornerstone.updateImage(dcmRef.current);
  }, [elmentEnabled, dicom_data.fluidBrushDrawingMode]);

  useEffect(() => {
    if (elmentEnabled) cornerstone.updateImage(dcmRef.current);
  }, [dicom_data.update]);

  useEffect(() => {
    if (elmentEnabled) {
      // If toggle annotation clicked for a line tool or delete annotation clicked
      let update_d = opData.OPT.annotation_toggle;

      if (update_d === undefined) {
        return;
      }
      const toolState = cornerstoneTools.getToolState(
        dcmRef.current,
        update_d.annot_type,
      );
      if (toolState === null || undefined) {
        return;
      }

      if (update_d.action_type === "visibility") {
        // Get new visibility state (toggle current value)
        const newVisibility = !toolState.data[update_d.index].visible;

        // Handle visibility toggle for both Line and AiSegmentation
        if (update_d.annot_type === "Line") {
          var imgIds = opData.OPT.stack.imageIds;

          const frames = [];
          for (var i = 0; i < imgIds.length; i++) {
            // Get frame annotations for all tools
            var toolAnnotations =
              cornerstoneTools.globalImageIdSpecificToolStateManager.getImageIdToolState(
                imgIds[i],
                "Line",
              );

            var j = update_d.index;
            if (
              toolAnnotations &&
              toolAnnotations.data &&
              toolAnnotations.data[j]
            ) {
              toolAnnotations.data[j].visible = newVisibility;
            }
            frames.push(toolAnnotations);
          }
        } else if (update_d.annot_type === "AiSegmentation") {
          // Simply toggle the visibility directly in the tool state
          const index = update_d.index;
          if (toolState.data[index]) {
            // Toggle visibility - default to true if undefined
            const currentVisibility = toolState.data[index].visible !== false;
            toolState.data[index].visible = !currentVisibility;

            // Apply this change to all frames
            const newVisibility = !currentVisibility;
            const imgIds = opData.OPT.stack.imageIds;

            // Update all frames manually
            imgIds.forEach((imageId) => {
              const frameToolState =
                cornerstoneTools.globalImageIdSpecificToolStateManager.getImageIdToolState(
                  imageId,
                  "AiSegmentation",
                );

              if (
                frameToolState &&
                frameToolState.data &&
                frameToolState.data[index]
              ) {
                frameToolState.data[index].visible = newVisibility;
              }
            });
          }
        }

        getToolsState();

        // Force React to update the UI by dispatching an update image action
        dispatch({ type: "UPDATE_IMAGE" });
        cornerstone.updateImage(dcmRef.current);
      } else if (update_d.action_type === "visibility_all") {
        toolState.visible = !toolState.visible;
        for (let i = 0; i < toolState.data.length; i++) {
          toolState.data[i].visible = toolState.visible;
        }
        // Update tool state

        getToolsState();
        // Force React to update the UI
        dispatch({ type: "UPDATE_IMAGE" });
        cornerstone.updateImage(dcmRef.current);
      } else if (update_d.action_type === "toggle_handles") {
        toolState.handles = !toolState.handles;

        getToolsState();
        // Force React to update the UI
        dispatch({ type: "UPDATE_IMAGE" });
        cornerstone.updateImage(dcmRef.current);
      } else if (update_d.action_type === "delete") {
        toolState.data.splice(update_d.index, 1);

        getToolsState();
        if (update_d.annot_type === "Lison") {
          dispatch({
            type: "ANNOTATION_CHANGE_REQUEST",
            stack_id: query.get("stack_id"),
            key: "OP",
            payload: {
              index: 0,
              annot_type: "LisonProbe",
              action_type: "Add_Lison_Length_point",
            },
          });
        }
      } else if (update_d.action_type === "toggle_Lison") {
        let imgIds = opData.OPT.stack.imageIds;
        let previous_values = [];
        for (var i = 0; i < imgIds.length; i++) {
          var toolAnnotations =
            cornerstoneTools.globalImageIdSpecificToolStateManager.getImageIdToolState(
              imgIds[i],
              "Lison",
            );

          if (toolAnnotations?.data) {
            if (!dicom_data.LisonActive) {
              let obj = {};
              obj[imgIds[i]] = toolAnnotations.data;
              previous_values = [...previous_values, obj];
              toolAnnotations.data = [];
            }
            if (dicom_data.LisonActive) {
              // let LisonData_dicom = dicom_data.LisonData;
              let foundObject = dicom_data.LisonData.find((obj) =>
                obj.hasOwnProperty(imgIds[i]),
              );
              if (foundObject) {
                toolAnnotations.data = foundObject[imgIds[i]];
              }
            }
          }
        }
        if (!dicom_data.LisonActive) {
          dispatch({
            type: "Lison_toggle_DATA",
            LisonData: previous_values,
          });
        }

        getToolsState();

        dispatch({
          type: "ANNOTATION_CHANGE_REQUEST",
          stack_id: query.get("stack_id"),
          key: "OP",
          payload: {
            index: 0,
            annot_type: "LisonProbe",
            action_type: "Add_Lison_Length_point",
          },
        });
      }
      cornerstone.updateImage(dcmRef.current);
    }
  }, [opData.OPT.annotation_toggle, dicom_data.LisonActive]);

  const metaDataProvider = (type, imageId) => {
    // Custom meta data provider for the viewport(OCT)
    if (type === "imagePlaneModule") {
      if (
        imageId.includes(opData.OPT.metadata.url) &&
        !isFluidManualPaintTool(dicom_data.selectedTool)
      ) {
        return {
          rows: opData.OPT.metadata.meta.height,
          columns: opData.OPT.metadata.meta.width,
          rowPixelSpacing: null, //opData.OPT.metadata.pixel_spacing.rowPixelSpacing,
          columnPixelSpacing: null, //opData.OPT.metadata.pixel_spacing.columnPixelSpacing,
        };
      }
    }
  };

  useEffect(() => {
    if (opData.OPT.metadata.pixel_spacing.rowPixelSpacing !== null) {
      cornerstone.metaData.addProvider(metaDataProvider);
    }
  }, [Object.keys(dicom_data.dicom_data).length, dicom_data.selectedTool]);

  useEffect(() => {
    const update_data = dicom_data.update_data;
    if (update_data.data) {
      var lineObj = {};
      for (var i = 0; i < update_data.data.length; i++) {
        lineObj[update_data.data[i].name] = update_data.data[i];
      }

      var toolStateOld = cornerstoneTools.getToolState(dcmRef.current, "Line");
      var toolStateOldN = {};
      if (toolStateOld.data) {
        var toolStateOld_data = [...toolStateOld.data];
        for (var i = 0; i < toolStateOld_data.length; i++) {
          toolStateOldN[toolStateOld_data[i].name] = toolStateOld_data[i];
        }
      }

      cornerstoneTools.clearToolState(dcmRef.current, "Line");

      var { lineNames } = dicom_data.lineSettings;
      for (var j = 0; j < lineNames.length; j++) {
        var lName = lineNames[j];
        if (lName in toolStateOldN) {
          // If Line is already in old annotations
          if (toolStateOldN[lName].visible && lName in lineObj) {
            // If it is visible and is in models output
            cornerstoneTools.addToolState(
              dcmRef.current,
              "Line",
              lineObj[lName],
            );
          } else {
            // Using old layers
            cornerstoneTools.addToolState(
              dcmRef.current,
              "Line",
              toolStateOldN[lName],
            );
          }
        } else if (lName in lineObj) {
          // Line is not available in old data
          cornerstoneTools.addToolState(dcmRef.current, "Line", lineObj[lName]);
        }
      }

      cornerstone.updateImage(dcmRef.current);
    }
  }, [dicom_data.update_data]);

  useEffect(() => {
    if (!elmentEnabled) {
      return;
    }
    const modifiedObject = normalizeOptAnnotationsByFrame(props.annotations);
    clearOptAnnotationToolState();

    isRestoringAnnotationsRef.current = true;
    try {
      addAnnotationsOPT(
        opData.OPT.stack.imageIds,
        modifiedObject,
        dicom_data.LisonActive,
        dicom_data?.settings,
        dicom_data?.aiSegmentationData,
        dicom_data?.fluidSegmentation,
      );
    } finally {
      isRestoringAnnotationsRef.current = false;
    }

    safeUpdateImage(dcmRef.current);
    if (
      dicom_data?.fluidSegmentation ||
      optAnnotationsHaveSavedFluid(modifiedObject)
    ) {
      safeUpdateImage(dcmRef.current);
    }
    if (ezdalinescheck(modifiedObject)) {
      dispatch({
        type: "ANNOTATION_CHANGE_REQUEST",
        stack_id: query.get("stack_id"),
        key: "OP",
        payload: {
          index: 0,
          annot_type: "LisonProbe",
          action_type: "Add_Lison_Length_point",
        },
      });
    }
    if (props.annotationSourceVersion > 0) {
      window.requestAnimationFrame(() => {
        props.onAnnotationSourceRendered?.();
      });
    }
  }, [
    dicom_data.LisonActive,
    dicom_data?.fluidSegmentation,
    props.annotationSourceVersion,
    elmentEnabled,
  ]);

  // Re-apply API fluid only for frames without saved FluidSegmentation annotations
  useEffect(() => {
    if (!elmentEnabled || !dicom_data?.fluidSegmentation) return;

    const modifiedObject = normalizeOptAnnotationsByFrame(props.annotations);

    applyFluidSegmentationToStack(
      opData.OPT.stack.imageIds,
      dicom_data.fluidSegmentation,
      dicom_data?.settings?.FluidSegmentation,
      null,
      modifiedObject,
    );
    snapshotFluidBaselinesForStack(
      props.id,
      opData.OPT.stack.imageIds,
      dicom_data?.activeFluidLabels,
    );
    dispatch({ type: "CLEAR_ALL_FLUID_DIRTY_FRAMES" });
    cornerstone.updateImage(dcmRef.current);
  }, [dicom_data?.fluidSegmentation, elmentEnabled]);

  useEffect(() => {
    if (
      !elmentEnabled ||
      !dcmRef.current ||
      !dicom_data?.fluidPayloadPointsVisible
    ) {
      return;
    }
    cornerstone.updateImage(dcmRef.current);
  }, [
    dicom_data.currentFrame,
    dicom_data?.fluidPayloadPointsVisible,
    elmentEnabled,
  ]);

  useEffect(() => {
    let element = dcmRef.current;

    cornerstone
      .loadImage(
        opData.OPT.stack.imageIds[opData.OPT.stack.currentImageIdIndex],
      )
      .then((image) => {
        // Enable the DOM Element for use with Cornerstone

        cornerstone.enable(element);
        cornerstone.displayImage(element, image);
        fitViewportToWidth(element, image);
        finalizeOptDisplay(element, image);
        setElementEnabled(true);

        // set the stack as tool state
        cornerstoneTools.addStackStateManager(element, ["stack", "Crosshairs"]);
        cornerstoneTools.addToolState(element, "stack", opData.OPT.stack);
        cornerstoneTools.addTool(StackScrollMouseWheelTool);
        cornerstoneTools.setToolActive("StackScrollMouseWheel", {});

        addRectangleStatic();
        addLineStatic();
        addAiSegmentation();
        addFluidSegmentation();

        const modifiedObject = normalizeOptAnnotationsByFrame(
          props.annotations,
        );

        isRestoringAnnotationsRef.current = true;
        try {
          addAnnotationsOPT(
            opData.OPT.stack.imageIds,
            modifiedObject,
            dicom_data.LisonActive,
            dicom_data?.settings,
            dicom_data?.aiSegmentationData,
            dicom_data?.fluidSegmentation,
          );
        } finally {
          isRestoringAnnotationsRef.current = false;
        }

        element.addEventListener(
          "cornerstonetoolsmeasurementadded",
          onMeasurementAdded,
        );
        element.addEventListener(
          "cornerstonetoolsmeasurementmodified",
          onMeasurementModified,
        );

        // ON New Cornerstone Image (Mouse Scroll)
        element.addEventListener("cornerstonenewimage", function (e) {
          incrementLoadCounter();
          const image = e.detail?.image ?? cornerstone.getImage(element);
          finalizeOptDisplay(element, image);
          dispatch({
            type: "DICOM_CHANGE_FRAME",
            changeType: "OPT",
            changeId: props.id,
            frame: cornerstoneTools.getToolState(element, "stack").data[0]
              .currentImageIdIndex,
          });

          getToolsState();
        });

        element.addEventListener("cornerstoneimagerendered", () => {
          applyTopconOptNearestNeighborCanvas(cornerstone, element);
        });

        // Add WWWC Tool
        cornerstoneTools.addTool(cornerstoneTools.WwwcTool);
        cornerstoneTools.setToolActive("Wwwc", { mouseButtonMask: 1 });

        getToolsState();
      })
      .then(() => {
        safeUpdateImage(element);
      });
  }, [Object.keys(dicom_data.dicom_data).length]);

  useEffect(() => {
    let element = dcmRef.current;
    element.addEventListener("cornerstonetoolsmousedown", onMouseDown);
    element.addEventListener("cornerstonetoolsmousemove", onMouseMove);
    element.addEventListener("cornerstonetoolsmouseup", onMouseUp);
    element.addEventListener("cornerstonetoolsmousedrag", onMouseDrag);
    element.addEventListener("cornerstonetoolsmouseclick", onMouseClick);
    element.addEventListener("cornerstonetoolsmousewheel", onMouseWheel);
    return () => {
      element.removeEventListener("cornerstonetoolsmousedown", onMouseDown);
      element.removeEventListener("cornerstonetoolsmouseup", onMouseUp);
      element.removeEventListener("cornerstonetoolsmousemove", onMouseMove);
      element.removeEventListener("cornerstonetoolsmousedrag", onMouseDrag);
      element.removeEventListener("cornerstonetoolsmouseclick", onMouseClick);
      element.removeEventListener("cornerstonetoolsmousewheel", onMouseWheel);
    };
  }, [
    dicom_data.currentFrame,
    dicom_data.selectedTool,
    dicom_data.segmentationEraserMode,
    dicom_data.selectedKey,
    dicom_data.manualFluidTargetLabel,
    dicom_data.fluidManualBrushRadius,
    dicom_data.fluidBrushDrawingMode,
    rectPoint,
  ]);

  useEffect(() => {
    if (!elmentEnabled || !dcmRef.current) return;
    if (
      isFluidManualPaintTool(dicom_data.selectedTool) &&
      dicom_data.manualFluidTargetLabel
    ) {
      try {
        cornerstoneTools.setToolPassive("Brush");
      } catch (_e) {
        /* noop */
      }
    }
  }, [
    elmentEnabled,
    dicom_data.selectedTool,
    dicom_data.manualFluidTargetLabel,
  ]);

  useEffect(() => {
    if (!isFluidManualPaintTool(dicom_data.selectedTool)) {
      fluidManualSessionRef.current.active = false;
      fluidManualSessionRef.current.points = [];
    }
  }, [dicom_data.selectedTool]);

  useEffect(() => {
    if (!elmentEnabled) return;
    const fd = dicom_data?.settings?.brush?.fluidEraserDiameter;
    syncFluidEraseDiameter(typeof fd === "number" ? fd : 20);
  }, [elmentEnabled, dicom_data?.settings?.brush?.fluidEraserDiameter]);

  useEffect(() => {
    if (!elmentEnabled) return;
    const aiDiameter = dicom_data?.settings?.brush?.borderRadius;
    syncAiSegmentationEraseDiameter(
      typeof aiDiameter === "number" ? aiDiameter : 20,
    );
  }, [elmentEnabled, dicom_data?.settings?.brush?.borderRadius]);

  useEffect(() => {
    if (!elmentEnabled) return;
    if (!isSegmentationEraserTool(dicom_data.selectedTool)) {
      if (cornerstoneTools.fluidEraseHover) {
        cornerstoneTools.fluidEraseHover = null;
        if (dcmRef.current) cornerstone.updateImage(dcmRef.current);
      }
    }
  }, [dicom_data.selectedTool, elmentEnabled]);

  // Hold Ctrl + wheel to resize the active segmentation eraser; plain wheel scrolls frames.
  useEffect(() => {
    if (!elmentEnabled) return;
    if (STACK_SCROLL_BLOCKING_KEYS.has(dicom_data.selectedKey)) {
      return;
    }
    const segmentationEraser = isSegmentationEraserTool(
      dicom_data.selectedTool,
    );
    const ctrlHeld = dicom_data.selectedKey === "Control";
    try {
      if (segmentationEraser && ctrlHeld) {
        cornerstoneTools.setToolDisabled("StackScrollMouseWheel");
      } else if (!["z", "Z"].includes(dicom_data.selectedKey)) {
        cornerstoneTools.setToolActive("StackScrollMouseWheel", {});
      }
    } catch (_e) {
      /* noop */
    }
  }, [dicom_data.selectedTool, dicom_data.selectedKey, elmentEnabled]);

  useEffect(() => {
    const el = dcmRef.current;
    if (!el || !elmentEnabled) return;

    const onNativeWheelCapture = (evt) => {
      const dc = dicomDataRef.current;
      if (!isSegmentationEraserCtrlResize(dc, evt)) {
        return;
      }

      evt.preventDefault();
      evt.stopPropagation();

      const spinY = evt.deltaY > 0 ? 1 : evt.deltaY < 0 ? -1 : 0;
      if (!spinY) return;

      const isFluid = isFluidSegmentationEraserTool(dc.selectedTool);
      const cur = isFluid
        ? (dc.settings?.brush?.fluidEraserDiameter ?? 20)
        : (dc.settings?.brush?.borderRadius ?? 20);
      const next = isFluid
        ? adjustFluidEraseDiameter(cur, spinY)
        : adjustAiSegmentationEraseDiameter(cur, spinY);
      if (next !== cur) {
        if (isFluid) {
          dispatch({ type: "SET_FLUID_ERASER_DIAMETER", diameter: next });
          syncFluidEraseDiameter(next);
        } else {
          dispatch({ type: "SET_BRUSH_BORDER_RADIUS", borderRadius: next });
          syncAiSegmentationEraseDiameter(next);
        }
        cornerstone.updateImage(el);
      }
    };

    el.addEventListener("wheel", onNativeWheelCapture, {
      capture: true,
      passive: false,
    });
    return () => {
      el.removeEventListener("wheel", onNativeWheelCapture, { capture: true });
    };
  }, [elmentEnabled, dispatch]);

  // Get annotations for all frames
  const getAllAnnotations = (imageIds, toolType) => {
    const allAnnotations = {};

    imageIds.forEach((imageId) => {
      const annotations =
        cornerstoneTools.globalImageIdSpecificToolStateManager.getToolState(
          imageId,
          toolType,
        );
      if (annotations) {
        allAnnotations[imageId] = annotations;
      }
    });

    return allAnnotations;
  };

  // Update annotations for all frames
  const updateAllAnnotations = (imageIds, toolType, updateFunction) => {
    const toolStateManager =
      cornerstoneTools.globalImageIdSpecificToolStateManager;

    const toolStates = {};

    imageIds.forEach((imageId) => {
      const imageToolState = toolStateManager.saveImageIdToolState(imageId);
      if (imageToolState) {
        toolStates[imageId] = imageToolState;
      }
    });

    const modifiedToolStates = { ...toolStates };

    Object.keys(modifiedToolStates).forEach((imageId) => {
      const imageToolState = modifiedToolStates[imageId];

      if (toolType === "Line") {
        const toolData = imageToolState["Line"];
        if (toolData && toolData?.data) {
          // Update visibility
          toolData?.data.forEach((item) => {
            item.visible =
              dicom_data?.settings?.Segmentation?.nativeSegmentation;
          });

          // If handles parameter is provided, also update handles property
          if (updateFunction.handles !== undefined) {
            toolData.handles = updateFunction.handles;
          }

          // Update specific line visibility if index is specified
          if (
            updateFunction.index !== undefined &&
            updateFunction.visibility !== undefined
          ) {
            if (toolData.data[updateFunction.index]) {
              toolData.data[updateFunction.index].visible =
                updateFunction.visibility;
            }
          }
        }
      } else if (toolType === "AiSegmentation") {
        const toolData = imageToolState["AiSegmentation"];
        if (toolData && toolData?.data) {
          // Update all AiSegmentation visibility
          if (updateFunction.visibility === undefined) {
            toolData?.data.forEach((item) => {
              item.visible = dicom_data?.settings?.Segmentation?.aiSegmentation;
            });
          }
          // Update specific segment visibility if index is provided
          else if (updateFunction.index !== undefined) {
            if (toolData.data[updateFunction.index]) {
              // Ensure the visibility value is explicitly set as a boolean
              toolData.data[updateFunction.index].visible =
                !!updateFunction.visibility;
            }
          }
        }
      }
    });

    Object.keys(modifiedToolStates)?.forEach((imageId) => {
      const imageToolState = modifiedToolStates[imageId];
      toolStateManager.restoreImageIdToolState(imageId, imageToolState);
    });
  };

  // Example usage to update visibility:

  // Listen for AISegmentation eraser completion events
  useEffect(() => {
    const handleErasingComplete = (evt) => {
      const dc = dicomDataRef.current;
      if (isFluidSegmentationEraserTool(dc?.selectedTool)) {
        dispatch({
          type: "MARK_FLUID_FRAME_DIRTY",
          frameIndex: dc.currentFrame,
        });
      }
      try {
        getToolsState();
      } catch (err) {
        console.warn("Annotation sync after erase skipped:", err);
      }
    };

    // Add event listener
    window.addEventListener(
      "aiSegmentationErasingComplete",
      handleErasingComplete,
    );

    // Remove event listener on cleanup
    return () => {
      window.removeEventListener(
        "aiSegmentationErasingComplete",
        handleErasingComplete,
      );
    };
  }, []); // Empty dependency array ensures this only runs once on mount

  const useSegmentationEraserCursor = isSegmentationEraserTool(
    dicom_data.selectedTool,
  );

  useEffect(() => {
    const el = dcmRef.current;
    if (!el || !elmentEnabled) {
      return;
    }

    const canvases = () =>
      Array.prototype.slice.call(el.querySelectorAll("canvas"));

    if (!useSegmentationEraserCursor) {
      el.style.removeProperty("cursor");
      canvases().forEach((c) => c.style.removeProperty("cursor"));
      return;
    }

    const cursorCss = "none";

    const applyCursor = () => {
      el.style.setProperty("cursor", cursorCss, "important");
      canvases().forEach((c) =>
        c.style.setProperty("cursor", cursorCss, "important"),
      );
    };

    const clearCursor = () => {
      el.style.removeProperty("cursor");
      canvases().forEach((c) => c.style.removeProperty("cursor"));
    };

    applyCursor();

    el.addEventListener("pointerenter", applyCursor);
    el.addEventListener("pointermove", applyCursor, { capture: true });
    el.addEventListener("pointerleave", clearCursor);
    el.addEventListener("cornerstonetoolsmousemove", applyCursor);
    el.addEventListener("cornerstonenewimage", applyCursor);

    return () => {
      el.removeEventListener("pointerenter", applyCursor);
      el.removeEventListener("pointermove", applyCursor, { capture: true });
      el.removeEventListener("pointerleave", clearCursor);
      el.removeEventListener("cornerstonetoolsmousemove", applyCursor);
      el.removeEventListener("cornerstonenewimage", applyCursor);
      clearCursor();
    };
  }, [elmentEnabled, useSegmentationEraserCursor]);

  // Handle updating all frames for handles visibility
  useEffect(() => {
    if (!elmentEnabled) return;

    // Check if there's an update request for handles on all frames
    const updateRequest =
      dicom_data?.update_data?.type === "UPDATE_ALL_FRAMES_HANDLES";

    if (updateRequest) {
      const payload = dicom_data.update_data.payload;

      // Only process if this is for the current viewer
      if (
        payload.stack_id === query.get("stack_id") &&
        payload.dcm_type === "OPT"
      ) {
        // Call updateAllAnnotations with the handles value
        updateAllAnnotations(payload.imageIds, "Line", {
          handles: payload.handles,
        });
        cornerstone.updateImage(dcmRef.current);
      }
    }
  }, [dicom_data?.update_data]);

  return (
    <div
      style={{
        height: props.height,
        width: props.width,
        backgroundColor: "#000",
      }}
      ref={dcmRef}
    ></div>
  );
}
